// extracted by mini-css-extract-plugin
export default {"starContainer":"starRating_starContainer__FE5TS","star":"starRating_star__8pzZp"};